import { CHECK_IN_APPOINTMENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    success: boolean;
    data: Data;
    error?: string;
}

export interface Data {
    appointment: Appointment;
}
export interface Appointment {
    date: string;
    doctor_oid: string;
    aid: string;
    p_aid: string;
    patient_uuid: string;
    patient_oid: string;
    poid: string;
    clinic_id: string;
    channel: string;
    onsched_id: string;
    status: string;
    full_date: string;
    start_time: string;
    end_time: string;
    visit_checkin?: null;
    visit_start?: null;
    visit_end?: null;
    created_at: string;
    payment_id?: null;
    payment_status?: null;
    sa_id?: null;
    tele_id?: null;
    amount: number;
    prescription_id?: null;
    follow_up?: null;
    callback_requested?: null;
    park_allowed?: null;
    updated_at: string;
    call_status?: null;
    patient_tele_status?: null;
    doctor_tele_status?: null;
    flavour?: null;
    attribute?: null;
    service: string;
    referral_id?: null;
    visit_count: number;
    last_visit_time: string;
    archive: boolean;
    prescription_url?: null;
    service_type: number;
    service_conf_id: string;
    mode: string;
    visit_type: string;
    doc_dwr_link?: null;
    phr_id?: null;
    dwr_link?: null;
    patient_profile: string;
    tags?: null[] | null;
    business_tags?: null[] | null;
    token?: null;
    comm_meta?: null;
    amount_collected?: null;
    discount_conf?: null;
    business_id: string;
}

export default (aid: string): Promise<RequestResponse> => {
    return fetchWithRefresh(CHECK_IN_APPOINTMENT(aid), {
        method: 'PUT',
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
